import { createSlice } from "@reduxjs/toolkit";
const PaymentDetailsSlice = createSlice({
  name: "PaymentDetails",
  initialState: {
    paymentData: "",
  },
  reducers: {
    storePaymentData: (state, action) => {
      console.log("action.payload:", action.payload);
      state.paymentData = action.payload;
    },

    clearPaymentData: (state, action) => {
      state.paymentData = "";
    },
  },
});

export const { storePaymentData, clearPaymentData } =
  PaymentDetailsSlice.actions;
export default PaymentDetailsSlice.reducer;
